import type { TFunction } from 'i18next';

/**
 * Пометы употребления значения (Oxford, тома НБАРС 2026-10-06) короткими подписями:
 * «разг.», «брит.», «обычно мн. ч.». На чипе переходность и исчисляемость не показываются
 * (они есть у половины глаголов и существительных — шум), в подробностях — все пометы;
 * неизвестная помета в подробностях показывается как есть.
 */
const KEYS: Record<string, string> = {
  informal: 'informal',
  formal: 'formal',
  slang: 'slang',
  literary: 'literary',
  'old-fashioned': 'oldFashioned',
  disapproving: 'disapproving',
  approving: 'approving',
  humorous: 'humorous',
  specialist: 'specialist',
  offensive: 'offensive',
  British: 'british',
  'North American': 'american',
  American: 'american',
  Australian: 'australian',
  Indian: 'indian',
  'New Zealand': 'newZealand',
  'South African': 'southAfrican',
  Scottish: 'scottish',
  Irish: 'irish',
  Canadian: 'canadian',
  'usually plural': 'usuallyPlural',
  plural: 'plural',
  uncountable: 'uncountable',
  'only before noun': 'beforeNoun',
  'usually before noun': 'beforeNoun',
  'not before noun': 'afterVerb',
  'usually passive': 'usuallyPassive',
  'often passive': 'usuallyPassive',
  singular: 'singular',
  'usually singular': 'singular',
  transitive: 'transitive',
  intransitive: 'intransitive',
  countable: 'countable',
};
const HIDDEN_ON_CHIP = new Set(['transitive', 'intransitive', 'countable']);

export interface Marked {
  registers: string[];
  region: string[];
  grammar: string[];
}

/** Подписи помет: full=false — для чипа (только известные, без переходности/исчисляемости),
 *  full=true — для подробностей (все, неизвестные как есть). */
export function markLabels(t: TFunction, x: Marked, full = false): string[] {
  const out: string[] = [];
  const parts = [...x.registers, ...x.region, ...x.grammar.flatMap((g) => g.split(/,\s*/))];
  for (const raw of parts) {
    const mark = raw.trim();
    if (!mark || (!full && HIDDEN_ON_CHIP.has(mark))) continue;
    const key = KEYS[mark];
    const label = key ? t(`cardsWorkspace.marks.${key}`) : full ? mark : '';
    if (label && !out.includes(label)) out.push(label);
  }
  return out;
}
